// import { types } from "../actions/ownerEMOChecklist";

// const initialState = {
//     sepratePropertyRemarks:null,
//     sepratePropertyObservation:null,
//     sepratePropertyONSite:null,
//     seprateProperty:null,
//     siteInspecionAttachedAllotement:null,
//     siteInspectionExtraOfferRemarks:null,
//     siteInspectionExtraOfferObservation:null,
//     extraOfferONSite:null,
//     siteInspecionExtraOffer:null,
//     siteInspecionWhetherconstructionRemarks:null,
//     siteInspecionWhetherconstructionObservation:null,
//     siteInspecionWhetherconstruction:null,
//     siteInspecionWhetherconstructionONSite:null,
//     siteInspecionAreaofextraONSite:null,
//     siteInspecionAreaofextraRemarks:null,
//     siteInspecionAreaofextraObservation:null,
//     siteInspecionAreaofextra:null,
//     siteInspecionDateArea:null,
//     siteInspecionDueDateArea:null,
//     siteInspectionRecommendation:null,
//     anyOtherDetailRemarkProposedSiteRemarks:null,
//     siteInspecionAnyOtheDetailObservation:null,
//     anyOtherDetailRemarkProposedSite:null,
//     siteInspecionAnyOtheDetail:null,
//     propertyShortageRemarks:null,
//     siteInspectionShortDistHeritageObservation:null,
//     propertyShortage:null,
//     siteInspecionPropertyShortage:null,
//     heritageDestinationRemarks:null,
//     siteInspectionHeritageDestObservation:null,
//     heritageDestination:null,
//     siteInspecionHeritageDestination:null,
//     isProposedPlotIsAffectedByPowerLineRemarks:null,
//     siteInspectionAffectedPowerObservation:null,
//     isProposedPlotIsAffectedByPowerLine:null,
//     siteInspecionPowerline:null,
//     infrastructureFacilitiesSupplyAvailbaleForPropertyRemarks:null,
//     siteInspectionInfraFacilityObservation:null,
//     infrastructureFacilitiesSupplyAvailbaleForProperty:null,
//     siteInspecioninfrastructureFacilities:null,
//     isPlotAdjoiningAnyGovernmentLandBuildingRemarks:null,
//     siteInspectionGovLandObservation:null,
//     isPlotAdjoiningAnyGovernmentLandBuilding:null,
//     siteInspecionisPlotAdjoiningAny:null,
//     isProposedPropertyInPossesionOfOwnerRemarks:null,
//     siteInspectionPossOfOwnerObservation:null,
//     isProposedPropertyInPossesionOfOwner:null,
//     siteInspecionisProposedProperty:null,
//     WidthOfApprochRoadToReachPropertyRemarks:null,
//     siteInspectionWidthOfRoadObservation:null,
//     widthOfApprochRoadToReachProperty:null,
//     siteInspecionWidthOfApprochRoadTo:null,
//     isLandRoadWideningGgreenBeltFallingInThePropertyRemarks:null,
//     siteInspectionGreenBeltObservation:null,
//     isLandRoadWideningGgreenBeltFallingInTheProperty:null,
//     siteInspecionisLandRoadWideningGgreen:null,
//     plotBoundariesandAreaAsPerRegisteryMatchesSiteRemarks:null,
//     siteInspectionRegMatchObservation:null,
//     plotBoundariesandAreaAsPerRegisteryMatchesSite:null,
//     siteInspecionplotBoundariesandArea:null,
//     locationShownOnDrawingMatchesPropertyRemarks:null,
//     siteInspectionPlanDrwingMatchObservation:null,
//     locationShownOnDrawingMatchesProperty:null,
//     siteInspecionLocationShownOnDrawing:null,
//     affectedByNaturalBodyRemarks:null,
//     siteInspectionAffctedNaturalBodyObservation:null,
//     affectedByNaturalBody:null,
//     siteInspecionaffectedByNaturalBody:null,
//     affectedByGasRemarks:null,
//     siteInspectionAffectedGasObservation:null,
//     siteInspecionaffectedByGas:null,
//     affectedByRailwayRemarks:null,
//     siteInspectionAffectedRailwayObservation:null,
//     siteInspecionaffectedByRailway:null,
//     affectedByDrainageRemarks:null,
//     siteInspectionAffectedDrainageObservation:null,
//     siteInspecionaffectedByDrainage:null,
//     affectedByElectricityRemarks:null,
//     siteInspectionAffectedElectricityObservation:null,
//     siteInspecionaffectedByElectricity:null,
//     affectedBySewerageRemarks:null,
//     siteInspectionAffctedBySewarageObservation:null,
//     siteInspecionaffectedBySeweragee:null,
//     affectedByWaterRemarks:null,
//     siteInspectionAffectedByWaterObservation:null,
//     siteInspecionaffectedByWater:null,
//     extraLandAllotedByRemarks:null,
//     siteInspectionExtraLandAllotedObservation:null,
//     siteInspecionextraLandAllotedBy:null,
//     siteInspecionPropertyGextraLandRemarks:null,
//     siteInspectionPropertyGextraLandObservation:null,
//     siteInspecionPropertyGextraLand:null,
//     siteInspecionPropertyGextra:null,
//     siteInspecionDemolationStartedRemarks:null,
//     siteInspectionDemolitionObservation:null,
//     siteInspecionDemolationStarted:null,
//     siteInspecionDemolitionStartedText:null,
//     siteInspecionBuiltRemarks:null,
//     siteInspectionBuiltObservation:null,
//     siteInspecionBuilttext:null,
//     siteInspecionConstructionStatusRemarks:null,
//     siteInspectionConstructionObservation:null,
//     siteInspecionConstructionStatus:null,
//     siteInspecionConstruction:null,
//     siteInspecionAnyOtherSideRemarks:null,
//     siteInspectionAnyOtherSideObservation:null,
//     siteInspecionAnyOtherSideONSite:null,
//     siteInspecionAnyOtherSide:null,
//     siteInspecionRightSideRemarks:null,
//     siteInspectionRightSideObservation:null,
//     siteInspecionRightSideONSite:null,
//     siteInspecionRightSide:null,
//     siteInspectionLeftSideObservation:null,
//     siteInspecionLeftSideONSite:null,
//     siteInspecionLeftSideRemarks:null,    
//     siteInspecionLeftSide:null,
//     siteInspecionRearSideObservation:null,
//     siteInspecionRearSideONSite:null,
//     siteInspecionRearSideRemarks:null,
//      siteInspecionRearSide:null,
//      siteInspectionFrontSideObservation:null,
//     siteInspecionFrontSideONSite:null,
//     siteInspecionFrontSideRemarks:null,
//      siteInspecionFrontSide:null,

// };
// export const siteInspectionReportReducer = (state = initialState, action) => {
    
//     switch (action?.type) {
//         case types.UPDATE_CHECKLIST_FORM_FIELD:
//             const newState = {
//                 ...state,
//                 [action.payload.name]: action.payload.value,
//             };
//             sessionStorage.setItem("inspectionReportData", JSON.stringify(newState));
//             return newState
//         default:
//             return state;
//     }
// };

import { types } from "../actions/formPurchasableFar";

const initialState = {
    inspectionReportData: {},
};

const siteInspectionReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.UPDATE_CHECKLIST_REVIEW:
      return {
        ...state,
        inspectionReportData: { ...state.inspectionReportData, ...action.payload },
      };
    default:
      return state;
  }
};

export default siteInspectionReportReducer;